

export const membersData = [
    {
        memberImg: "assets\images\payment\mastercard.svg",
        memberName:'Amelia Green',
        memberEmail:'amelia.green@company.com'
    },
    {
        memberImg: "assets\images\payment\mastercard.svg",
        memberName:'Charlotte Green',
        memberEmail:'charlotte.green@company.com'
    },
    {
        memberImg: "assets\images\payment\mastercard.svg",
        memberName:'Susie Willis',
        memberEmail:'susie.willis@company.com'
    }
]